import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Wrapper } from "..";
import Budgets from "./content/budgets";
import Repair from "./content/repair";
import SLA_Graph from "./content/sla_graph";
import TypeBox from "./content/type";
import Unit from "./content/unit";
import Waiting from "./content/waiting";
import Workload from "./content/workload";

const HomeCare = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Row gutter={[14, 14]}>
        <Col span={24} style={{fontSize: 18, fontWeight: 600}}>{t("property.house-care-service", { ns: "menu" })}</Col>
        <Col span={24}>
          <Repair />
        </Col>
        <Col md={24} lg={24} xl={8}>
          <Waiting />
        </Col>
        <Col md={24} lg={24} xl={16}>
          <Budgets />
        </Col>
        <Col md={24} lg={10} xl={12}>
          <Unit />
        </Col>
        <Col md={24} lg={14} xl={12}>
          <TypeBox />
        </Col>
        <Col span={24}>
          <Workload />
        </Col>
        <Col span={24}>
          <SLA_Graph />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default HomeCare;
